<app-edit-product-form [productId]="productId()" [subProductId]="subProductId()" [productType]="productType()" />
